import type { IIcon, IIconPosition, ITranslationkey } from '@/components/Interfaces';
import type { DropdownItemTypes } from './DropdownItemTypes';
import type { IconName, StackedIcon } from '@/fontawesome';
import type { IconFamily } from '@/components/Interfaces/IIcon';
import { DropdownItemBase } from './DropdownItemBase';
import type { Ref } from 'vue';

interface IDropdownItemMenu extends IIcon, IIconPosition {
    dropdownItems: DropdownItemTypes[];
    translationkey?: Ref<string> | string;
    hideDropDownItem?: Ref<boolean>;
}

// TODO: Change to have the same format as the other dropdown items

export class DropdownItemMenu extends DropdownItemBase implements IIcon, IIconPosition {
    dropdownItems: DropdownItemTypes[];

    icon?: IconName | StackedIcon;
    iconFamily?: IconFamily;
    iconPosition?: 'left' | 'right' | 'top';
    translationkey?: Ref<string> | string;

    get uniqueLoopKey() {
        return `${this.translationkey}-${this.icon}`;
    }

    private abuseBlocker = false;

    private constructor(options: IDropdownItemMenu) {
        super();
        this.dropdownItems = options.dropdownItems;
        this.icon = options.icon;
        this.iconFamily = options.iconFamily;
        this.iconPosition = options.iconPosition;
        this.translationkey = options.translationkey;
        this.hideDropDownItem = options.hideDropDownItem;
    }

    public static create(
        options: Partial<IDropdownItemMenu> & Pick<IDropdownItemMenu, 'dropdownItems'> & Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemMenu {
        return new DropdownItemMenu({
            dropdownItems: options.dropdownItems,
            icon: options.icon,
            iconFamily: options.iconFamily,
            iconPosition: options.iconPosition,
            translationkey: options.translationkey,
            hideDropDownItem: options.hideDropDownItem,
        });
    }
}
